import { useTranslation } from "react-i18next";
import { type FeedbackState } from "@/components/FeedbackButtons";

interface RatingStatusBadgeProps {
  feedbackState?: FeedbackState;
}

export function RatingStatusBadge({ feedbackState }: RatingStatusBadgeProps) {
  const { t } = useTranslation("common");
  let dotColor: string;
  let label: string;

  if (!feedbackState) {
    dotColor = "bg-orange-500";
    label = t("rating.unrated");
  } else if (feedbackState.signal === "relevant") {
    dotColor = "bg-green-500";
    label = t("rating.rated");
  } else {
    dotColor = "bg-red-500";
    label = t("rating.irrelevant");
  }

  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground shrink-0">
      <span
        data-testid="rating-dot"
        className={`w-1.5 h-1.5 rounded-full ${dotColor}`}
      />
      {label}
    </span>
  );
}
